"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var button_1 = tslib_1.__importDefault(require("../../button"));
var DrawerFooterBtns = function (props) {
    var handleOk = props.handleOk, handleCancel = props.handleCancel, _a = props.hasError, hasError = _a === void 0 ? false : _a, _b = props.isDisable, isDisable = _b === void 0 ? false : _b, _c = props.okText, okText = _c === void 0 ? '确定' : _c, _d = props.cancelText, cancelText = _d === void 0 ? '取消' : _d, mainPageKey = props.mainPageKey, activeKey = props.activeKey;
    return (react_1.default.createElement("div", { className: "anq-bottomBtn" },
        react_1.default.createElement(button_1.default, { onClick: handleOk, disabled: hasError || isDisable, type: activeKey === mainPageKey ? 'primary' : 'ghost' }, okText),
        react_1.default.createElement(button_1.default, { onClick: handleCancel, type: "default" }, cancelText)));
};
exports.default = DrawerFooterBtns;
//# sourceMappingURL=Footer.js.map